import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../auth/auth.service';

export const MetadataInterceptor: HttpInterceptorFn = (req, next) => {

  const authService = inject(AuthService);

  if (req.method === 'POST' || req.method === 'PUT' || req.method === 'PATCH') {
    const currentDate = new Date().toISOString();

    const currentUser = authService.getCurrentUserSync();
    const currentUserId = `${currentUser?.first_name} ${currentUser?.last_name}` || 'system';

    if (!req.body || typeof req.body !== 'object') {
      return next(req);
    }

    let modifiedBody = { ...req.body } as any;

    if (req.method === 'POST') {
      modifiedBody.metadata = {
        created_date: currentDate,
        created_by: currentUserId,
        updated_date: currentDate,
        updated_by: currentUserId
      };
    } else if (req.method === 'PUT' || req.method === 'PATCH') {
      modifiedBody['metadata.updated_date'] = currentDate;
      modifiedBody['metadata.updated_by'] = currentUserId;
    }

    const modifiedRequest = req.clone({
      body: modifiedBody
    });

    return next(modifiedRequest);
  }

  return next(req);

};
